import {DropdownComponent} from './dropdown.component';

export const DROPDOWN_COMPONENTS = [
    DropdownComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/dropdown/index.ts